import { getStateStore } from '../../stores';

const state = getStateStore('ipc');

let lastDisplay = -1;
export const initializeDisplayEvents = () => {
  state.displayState.addListener((displayState) => {
    if (displayState.info.selectedDisplayId === -1) {
      if (lastDisplay === -1) {
        const primaryDisplayId = displayState.displays.find((display) => display.properties.isPrimary)?.displayId;
        if (primaryDisplayId !== undefined) {
          lastDisplay = primaryDisplayId;
          state.displayState.currentState.info.selectedDisplayId = primaryDisplayId;
          state.displayState.updateState({
            ...displayState,
            info: {
              selectedDisplayId: primaryDisplayId,
            },
          });
        }
      } else {
        state.displayState.currentState.info.selectedDisplayId = lastDisplay;
        state.displayState.updateState({
          ...displayState,
          info: {
            selectedDisplayId: lastDisplay,
          },
        });
      }
    }
  });
};
